import React from 'react';
import { RingLoader } from 'react-spinners';

const Button = (props) => {
  const { wrapperStyle, color, loading, size } = props;
  return (
    <div style={ wrapperStyle }>
      <RingLoader
        color={color || '#59E3CE'}
        loading={loading || false}
        size={size || 28}
      />
    </div>
  );
}

export default Button;
